import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { openModal } from '../../redux/Slices/modalSlice';
import { togglePopover } from '../../redux/Slices/popoverSlice';
import './scss/IntelligenceMenu.scss';

const IntelligenceMenu = ({ boardId, board }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleAnalyticsClick = () => {
        navigate(`/b/${board.shortId}/analytics`);
        dispatch(togglePopover({ contentId: null, position: { top: 0, left: 0 }, targetId: null }));
    };

    const handleAIFeatureClick = (featureType) => {
        dispatch(openModal({
            modalType: 'INTELLIGENCE',
            modalData: {
                featureType,
                boardId: boardId || board?.shortId,
                boardTitle: board?.title || 'Board'
            }
        }));
        dispatch(togglePopover({ contentId: null, position: { top: 0, left: 0 }, targetId: null }));
    };

    const intelligenceMenuItems = [
        {
            icon: <span className="material-symbols-outlined">monitoring</span>,
            label: "Analytics",
            description: "View board performance metrics",
            action: handleAnalyticsClick
        },
        {
            icon: <span className="material-symbols-outlined">psychology</span>,
            label: "AI Insights",
            description: "Smart recommendations and analysis",
            action: () => handleAIFeatureClick('AIInsights')
        },
        {
            icon: <span className="material-symbols-outlined">auto_awesome</span>,
            label: "Card Suggestions",
            description: "AI-powered card ideas",
            action: () => handleAIFeatureClick('CardSuggestions')
        },

        // {
        //     icon: <span className="material-symbols-outlined">text_snippet</span>,
        //     label: "Text to Tasks",
        //     description: "Convert text to actionable tasks",
        //     action: () => handleAIFeatureClick('TextToTasksParser')
        // }
    ];

    return (
        <div className="ai-menu-popover">
            <div className="ai-menu-header">
                <div className="ai-menu-title">
                    <span className="material-symbols-outlined">auto_awesome</span>
                    <span>Intelligence</span>
                </div>
                <p className="ai-menu-subtitle">AI-powered tools and insights</p>
            </div>

            <div className="ai-menu-items">
                {intelligenceMenuItems.map((item, index) => (
                    <div
                        key={index}
                        className="ai-menu-item"
                        onClick={item.action}
                    >
                        <div className="ai-menu-item-icon">
                            {item.icon}
                        </div>
                        <div className="ai-menu-item-content">
                            <div className="ai-menu-item-label">{item.label}</div>
                            <div className="ai-menu-item-description">{item.description}</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default IntelligenceMenu;
